import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class CategoryService {

  constructor(private http: HttpClient, private global: GlobalDataService) {}


   getCategory(isActive:number=-1) {
        
    let isAvailable: string ="?active="+isActive
    if(isActive==-1){
        isAvailable="";
    }
        return this.http.get(this.global.httpUrl+"categories"+isAvailable);
    }

   getCategoryById(id: any) {
        return this.http.get(this.global.httpUrl+"categories/"+id);
    } 

   createCategory(data: any){
        return this.http.post(this.global.httpUrl+"categories", data);
    }

   updateCategory(data: any,id: any){
        return this.http.put(this.global.httpUrl+"categories/"+id, data);
    } 

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/categories/category.service.ts